import { makeAutoObservable, observable  } from "mobx";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { preferenceService } from "../services/preferenceService";
class PreferenceStore {
  constructor() {
    makeAutoObservable(this);
  }

  preference = {};
  dateFormats = [
    { key: "DD.MMM.YYYY", text: "01.Jan.2020" },
    { key: "DD/MMM/YYYY", text: "01/Jan/2020" },
    { key: "DD/MMMM/YYYY", text: "01/January/2020" },
    { key: "Do/MMMM/YYYY", text: "1st/January/2020" },
    { key: "Do/MMM/YYYY", text: "1st/Jan/2020" },
    { key: "Do-MMM-YYYY", text: "1st-Jan-2020" },
    { key: "DD/MMM/YYYY", text: "01-Jan-2020" },
    { key: "DD/MMMM/YYYY", text: "01-January-2020" },
    { key: "MMM/DD/YYYY", text: "Jan/01/2020" },
    { key: "MM/DD/YY", text: "01/01/20" },
    { key: "DD/MM/YY", text: "01/01/20" },
    { key: "ddd DD-MMM-YYYY", text: "Wed 01-Jan-2020" },
    { key: "DD.MM.YYYY", text: "01.01.2020" },
    { key: "DD.MM.YY", text: "01.01.20" },
  ];
  async savePreference(preference) {
    try {
      await preferenceService.savePreference(preference);
    } catch (error) {
      throw error;
    }
  }

  async loadPreference() {
    try {
      const userId = getCurrentUser()?.id;
      const retVal = await preferenceService.loadPreference(userId);

      this.preference = retVal;
    } catch (error) {
      throw error;
    }
  }
}


const preferenceStore = new PreferenceStore();
export default preferenceStore;

